var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vehicle-form',{attrs:{"handler":_vm.createVehicle,"form":this.form,"fleet-uuid":_vm.fleetUuid,"is-popup":_vm.isPopup},on:{"go-back":function($event){return _vm.$emit('close-dialog', true)}}}),(_vm.isLoading)?_c('sp-loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }